"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _RecentPerformanceControls = _interopRequireDefault(require("./RecentPerformanceControls"));

var _FifteenMinuteChart = _interopRequireDefault(require("./FifteenMinuteChart"));

var _DailyChart = _interopRequireDefault(require("./DailyChart"));

var _MonthlyChart = _interopRequireDefault(require("./MonthlyChart"));

var _CumulativeChart = require("./CumulativeChart");

var _AlertHistoryChart = _interopRequireDefault(require("./AlertHistoryChart"));

var _FieldServiceActivityChart = _interopRequireDefault(require("./FieldServiceActivityChart"));

var _hooks = require("../hooks");

var _views = require("../constants/views");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var PerformanceCharts = function PerformanceCharts(_ref) {
  var analytics = _ref.analytics,
      alertData = _ref.alertData,
      authToken = _ref.authToken,
      baseUrl = _ref.baseUrl,
      disableCumulative = _ref.disableCumulative,
      hasBatteryProp = _ref.hasBattery,
      hasCTProp = _ref.hasCT,
      internalUsage = _ref.internalUsage,
      isOrangeCustomer = _ref.isOrangeCustomer,
      maxDateISO = _ref.maxDateISO,
      minDateISO = _ref.minDateISO,
      prospectId = _ref.prospectId,
      storageProfile = _ref.storageProfile,
      timeZone = _ref.timeZone,
      viewConfig = _ref.viewConfig,
      withBatteryChart = _ref.withBatteryChart;
  if (!authToken || !baseUrl || !prospectId) return null;
  var siteProductionDaily = (0, _hooks.useDailyPerformance)(prospectId, minDateISO, maxDateISO, baseUrl, authToken) || [];
  var fieldServiceActivity = (0, _hooks.useFSDispatch)(prospectId, baseUrl, authToken) || [];
  var productOffering = (0, _hooks.useProductOffering)(prospectId, baseUrl, authToken) || {};
  var brightBox = productOffering.brightBox,
      hasConsumption = productOffering.hasConsumption;
  var hasBattery = Boolean(hasBatteryProp || brightBox);
  var hasCT = Boolean(hasCTProp || hasConsumption);
  return /*#__PURE__*/_react["default"].createElement(_RecentPerformanceControls["default"], {
    analytics: analytics,
    authToken: authToken,
    baseUrl: baseUrl,
    disableCumulative: disableCumulative,
    fieldServiceActivity: fieldServiceActivity,
    hasBattery: hasBattery,
    hasCT: hasCT,
    internalUsage: internalUsage,
    isOrangeCustomer: isOrangeCustomer,
    maxDateISO: maxDateISO,
    meterReadings: siteProductionDaily,
    minDateISO: minDateISO,
    prospectId: prospectId,
    timeZone: timeZone,
    viewConfig: viewConfig
  }, function (_ref2) {
    var activeDataValues = _ref2.activeDataValues,
        chartType = _ref2.chartType,
        viewEndISO = _ref2.viewEndISO,
        viewStartISO = _ref2.viewStartISO,
        view = _ref2.view;
    var minMaxDateProps = {
      maxDateISO: maxDateISO,
      minDateISO: minDateISO
    };
    var displayDateProps = {
      timeZone: timeZone,
      viewEndISO: viewEndISO,
      viewStartISO: viewStartISO
    };
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (view === _views.DAILY || view === _views.WEEKLY) && /*#__PURE__*/_react["default"].createElement(_FifteenMinuteChart["default"], _extends({
      activeDataValues: activeDataValues,
      authToken: authToken,
      baseUrl: baseUrl,
      hasBattery: hasBattery,
      hasCT: hasCT,
      prospectId: prospectId,
      storageProfile: internalUsage ? storageProfile : {},
      withBatteryChart: withBatteryChart,
      internalUsage: internalUsage
    }, displayDateProps)), view === _views.MONTHLY && chartType === _views.STANDARD && /*#__PURE__*/_react["default"].createElement(_DailyChart["default"], _extends({
      activeDataValues: activeDataValues,
      authToken: authToken,
      baseUrl: baseUrl,
      hasBattery: hasBattery,
      hasCT: hasCT,
      internalUsage: internalUsage,
      prospectId: prospectId,
      storageProfile: internalUsage ? storageProfile : {},
      withBatteryChart: withBatteryChart
    }, displayDateProps)), view === _views.ALL && chartType === _views.STANDARD && /*#__PURE__*/_react["default"].createElement(_MonthlyChart["default"], _extends({
      activeDataValues: activeDataValues,
      authToken: authToken,
      baseUrl: baseUrl,
      hasBattery: hasBattery,
      hasCT: hasCT,
      internalUsage: internalUsage,
      isOrangeCustomer: isOrangeCustomer,
      prospectId: prospectId
    }, displayDateProps)), !disableCumulative && chartType === _views.CUMULATIVE && view === _views.MONTHLY && /*#__PURE__*/_react["default"].createElement(_CumulativeChart.CumulativeDailyChartContainer, _extends({
      activeDataValues: activeDataValues,
      authToken: authToken,
      baseUrl: baseUrl,
      hasBattery: hasBattery,
      prospectId: prospectId,
      internalUsage: internalUsage
    }, displayDateProps, minMaxDateProps)), !disableCumulative && chartType === _views.CUMULATIVE && view === _views.ALL && /*#__PURE__*/_react["default"].createElement(_CumulativeChart.CumulativeMonthlyChartContainer, _extends({
      activeDataValues: activeDataValues,
      authToken: authToken,
      baseUrl: baseUrl,
      hasBattery: hasBattery,
      prospectId: prospectId,
      internalUsage: internalUsage
    }, displayDateProps, minMaxDateProps)), internalUsage && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_AlertHistoryChart["default"], _extends({
      alerts: alertData
    }, displayDateProps)), /*#__PURE__*/_react["default"].createElement(_FieldServiceActivityChart["default"], _extends({
      fieldServiceActivity: fieldServiceActivity
    }, displayDateProps))));
  });
};

PerformanceCharts.propTypes = {
  analytics: _propTypes["default"].shape({
    track: _propTypes["default"].func
  }),
  alertData: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  authToken: _propTypes["default"].string.isRequired,
  baseUrl: _propTypes["default"].string.isRequired,
  disableCumulative: _propTypes["default"].bool,
  fieldServiceActivity: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  hasBattery: _propTypes["default"].bool,
  hasCT: _propTypes["default"].bool,
  internalUsage: _propTypes["default"].bool,
  isOrangeCustomer: _propTypes["default"].bool,
  maxDateISO: _propTypes["default"].string.isRequired,
  minDateISO: _propTypes["default"].string.isRequired,
  prospectId: _propTypes["default"].string.isRequired,
  storageProfile: _propTypes["default"].shape({
    storageMode: _propTypes["default"].string,
    storageProfileDetails: _propTypes["default"].shape({
      name: _propTypes["default"].string
    })
  }),
  timeZone: _propTypes["default"].string.isRequired,
  viewConfig: _propTypes["default"].shape({
    chartType: _propTypes["default"].string.isRequired,
    endDate: _propTypes["default"].string.isRequired,
    startDate: _propTypes["default"].string.isRequired,
    view: _propTypes["default"].string.isRequired
  }),
  withBatteryChart: _propTypes["default"].bool
};
PerformanceCharts.defaultProps = {
  analytics: {
    track: function track() {}
  },
  alertData: [],
  disableCumulative: false,
  fieldServiceActivity: [],
  hasBattery: false,
  hasCT: false,
  internalUsage: false,
  isOrangeCustomer: false,
  storageProfile: {},
  viewConfig: {
    chartType: _views.STANDARD,
    view: _views.MONTHLY,
    endDate: '',
    startDate: ''
  },
  withBatteryChart: false
};
var _default = PerformanceCharts;
exports["default"] = _default;